import axios from "axios";
import Util from "../streaming/Util";

class recordingSession {
	
	constructor()
		{
			this.recordVideoStream = false;
			this.recordAudioStream = false;
			this.aTrack = false;
			
			this.AC = window.AudioContext || window.webkitAudioContext;
			this.audioCtx = new this.AC();
			this.streamDestination = this.audioCtx.createMediaStreamDestination();
			
			this.isRecordingNow = false;
			this.isRecordingStarted = false;
			this.hasRecordingFiles = false;
			
			this.mediaRecordObject = {};
			this.recordingInterval = 60000;
			
			this.recordingPath = '';
			if ( window['electron'] && window['recordingPath'] ) { this.recordingPath = window['recordingPath'].replace(/\\/g, '/')+'/recordingsod/'; }
			
			if ( window['electron'] && window['recordingPath'] && window['fsFile'] )
				{
					if ( !window['fsFile'].existsSync(window['recordingPath'].replace(/\\/g, '/')+'/recordingsod') )
						{
							window['fsFile'].mkdirSync(window['recordingPath'].replace(/\\/g, '/')+'/recordingsod');
						}
				}
			
			this.callBackOnStop = false;
			
			this.recordingFileFullV = '';
			this.recordingFileFullA = '';
			this.recordingFileFullT = '';
			
			this.logDetails = {};
			this.dataObject = false;
			
			
			this.browserData = '';
			this.participantStreams = [];
			this.participantTracks = [];
			
			this.progressBar = 0;
			
			this.saveTries = 3;
			
			this.failedAudioFile = false;
			
			this.recordingStarted = new Date().getTime();
			this.recordingDuration = 0;
			
			this.uniqueRecordingFile = 'rec_' + (new Date()).getTime();
			this.currentRecordingItem = 0;
			
			this.lastClipTimer = 0;
		}
	
	startRecording(forceNewClip)
		{
			var $ = window.$ || {};
			
			// Check does target canvas element exists and create stream from it
			if ( !$('#video_precanvas')[0] ) { this.sendLogData('RecordingError', 'Element Not Found', 'Canvas for recording not found'); console.error('Unable to find recording element'); return false; }
			if ( !this.recordVideoStream ) { this.recordVideoStream = $('#video_precanvas')[0].captureStream(60); }
			if ( this.isRecordingNow && !forceNewClip ) { this.sendLogData('RecordingError', 'Already Recording', 'Recording already started');  console.error('Already recording'); return false; }
			
			if ( !forceNewClip ) { this.uniqueRecordingFile = 'rec_' + (new Date()).getTime(); }
			
			this.recordingFileFullV = this.uniqueRecordingFile + '_'+this.currentRecordingItem+'.mkv';
			this.recordingFileFullA = this.uniqueRecordingFile + '_'+this.currentRecordingItem+'.aac';
			this.recordingFileFullT = this.uniqueRecordingFile + '.txt';
			
			this.callBackOnStop = false;
			if ( !forceNewClip ) { this.recordingStarted = new Date().getTime(); }
			
			// Only if electron do recording with Agora
			if ( window['electron'] )
				{
					if ( !forceNewClip ) { window['fsFile'].writeFile(this.recordingPath+this.recordingFileFullT, localStorage.getItem("userData"), function (err) { }); }
					
					if ( !window['globalAgora'] || !window['globalAgora'].agora ) { this.sendLogData('RecordingError', 'Agora Error', 'Unable to start agora recording.'); console.error('Unable to start Agora recording.'); return false; }
					
					var startedAgore = window['globalAgora'].agora.startAudioRecording(this.recordingPath+this.recordingFileFullA, 48000, 2);
					if ( startedAgore !== 0 ) { this.sendLogData('RecordingError', 'Agora Error', 'Unable to start agora recording.'); console.error('Unable to start Agora recording.'); return false; }
				}
			
			this.saveTries = 3;
			this.isRecordingStarted = true;
			this.setupMediaRecorder(forceNewClip);
			
			var mainThis = this;
			window['clipRec'] = function () { mainThis.clipRecording(); };
		}
	
	stopRecording(callback)
		{
			if ( this.callBackOnStop ) { return false; } // Already saving
			if ( callback ) { this.callBackOnStop = callback; }
			if ( this.isRecordingNow == false && callback ) { callback(); return false; }
			if ( this.isRecordingNow == false ) { return false; }
			
			if ( window['electron'] ) { window['globalAgora'].agora.stopAudioRecording(); }
			
			var mainThis = this;
			
			setTimeout(function ()
				{
					mainThis.recordingDuration = new Date().getTime() - mainThis.recordingStarted;
					mainThis.mediaRecordObject[mainThis.currentRecordingItem].stop();
				}, 2000);
			
			this.isRecordingNow = false;
			this.hasRecordingFiles = true;
		}
	
	checkAACSaved(callback, itemid)
		{
			if ( !window['electron'] ) { callback(); return true; }
			
			var mainThis = this;
			try
				{
					var stats = window['fsFile'].statSync(mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+itemid+'.aac')
					var fileSizeInBytes = stats.size;
					
					if ( this.saveTries <= 0 )
						{
							this.sendLogData('RecordingNext', 'No Audio Saved', 'No Audio Saved');
							console.error('No Audio Saved');
							
							this.failedAudioFile = true;
							callback(); // Try to save video
							
							return false;
						}
					
					if ( fileSizeInBytes > 10 )
						{
							callback();
						}
					else
						{
							setTimeout(function () { mainThis.saveTries--; mainThis.checkAACSaved(callback, itemid); }, 3000);
						}
				}
			catch (e)
				{
					this.sendLogData('RecordingError', 'Unable to Find size of AAC', 'Unable to Find size of AAC');
					console.error('Unable to Find size of AAC', e);
					
					this.failedAudioFile = true;
					callback(); // Try to save video
				}
		}
	
	checkMKVSize(pathCheck)
		{
			try
				{
					var stats = window['fsFile'].statSync(pathCheck)
					var fileSizeInBytes = stats.size;
					
					if ( fileSizeInBytes > 10 )
						{
							return true;
						}
				}
			catch (e)
				{
					this.sendLogData('RecordingError', 'Unable to Find size of MKV', 'Unable to Find size of MKV');
					console.error('Unable to Find size of MKV', e);
					
					return false;
				}
			
			return false;
		}
	
	doUpdateStreams(streamArray)
		{
			var mainThis = this;
			if ( window['electron'] ) { return false; }
			
			if ( streamArray ) { this.participantStreams = streamArray; }
			
			
			if ( this.isRecordingStarted == false ) { return false; }
			
			// No change in Participants Streams, only host
			if ( !streamArray )
				{
					try
						{
							if ( this.aTrack && this.aTrack.stop ) { this.aTrack.stop(); }
							
							if ( window['mainLocalStream'] && window['mainLocalStream'].stream )
								{
									this.recordAudioStream = window['mainLocalStream'].stream;
									this.aTrack = this.recordAudioStream.getAudioTracks()[0].clone();
									var source1 = this.audioCtx.createMediaStreamSource(new MediaStream([this.aTrack]));
									source1.connect(this.streamDestination);
									
									console.log('Instructor Audio Recording');
								}
							else
								{
									mainThis.sendLogData('RecordingError', 'High Priority - Instructor Audio Recording', 'Error adding INSTRUCTOR STREAM to recording from');
									console.log('Error adding Instructor STREAM to recording from');
								}
						}
					catch (err)
						{
							mainThis.sendLogData('RecordingError', 'High Priority - Instructor Audio Recording ', 'Error adding Instructor to recording');
							console.log('Error adding Instructor to recording');
						}
					
				}
			
			// ReInitiate Participant Streams
			if ( this.participantStreams )
				{
					var newListPart = [];
					this.participantStreams.forEach((stream) =>
						{
							if (stream.getId() != undefined)
								{
									try
										{
											if ( this.participantTracks.indexOf(stream.getId()) < 0 )
												{
													var source2 = this.audioCtx.createMediaStreamSource(new MediaStream([stream.getAudioTrack()]));
													source2.connect(this.streamDestination);
												}
											
											newListPart.push(stream.getId());
										}
									catch (err)
										{
											mainThis.sendLogData('RecordingError', 'Low Priority - Participant Recording ', 'Error adding participant to recording');
											console.log('Error adding participant to recording');
										}
								}
						});
					
					this.participantTracks = newListPart;
				}
		}
	
	setupMediaRecorder(forceNewClip)
		{
			var mainThis = this;
			if ( !window['electron'] && window['mainLocalStream'] )
				{
					this.doUpdateStreams();
					
					var fullStreamer = new MediaStream([this.recordVideoStream.getVideoTracks()[0], this.streamDestination.stream.getAudioTracks()[0]]);
					this.mediaRecordObject[mainThis.currentRecordingItem] = new MediaRecorder(fullStreamer);
				}
			else
				{
					this.mediaRecordObject[mainThis.currentRecordingItem] = new MediaRecorder(this.recordVideoStream);
				}
			
			var MROid = mainThis.currentRecordingItem;
			var chunks = [];
			this.mediaRecordObject[mainThis.currentRecordingItem].ondataavailable = function(e)
				{
					chunks.push(e.data);
					if ( mainThis.isRecordingNow ) { mainThis.saveFileDate(chunks, false, false, false, MROid); }
				}
			
			this.mediaRecordObject[mainThis.currentRecordingItem].onerror = function(){ mainThis.sendLogData('RecordingError', 'mediaRecorder error', 'Error in media recorder.'); console.log('Error recording'); }
			
			this.mediaRecordObject[mainThis.currentRecordingItem].onstop = function() { mainThis.saveFileDate(chunks, true, false, false, MROid); }

			this.mediaRecordObject[mainThis.currentRecordingItem].start(this.recordingInterval);
			this.isRecordingNow = true;
		}
	
	saveFileDate(chunks, isLast, secondTry, noBackingUp, MROid)
		{
			var mainThis = this;
			let blob = new Blob(chunks, { 'type' : 'video/mkv' });
			
			if ( window['electron'] )
				{
					console.log('file size', blob);
					console.log('file size', chunks.length);
					
					var fullPath = mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+MROid+'.mkv';;
					
					if ( window['fsFile'].existsSync(fullPath) )
						{
							var goodSize = mainThis.checkMKVSize(fullPath);
							if ( noBackingUp || !goodSize )
								{
									mainThis.saveFileMKV(fullPath, blob, chunks, isLast, secondTry, MROid);
								}
							else
								{
									if ( window['fsFile'].existsSync(fullPath.replace('.mkv', '_backup.mkv')) )
										{
											window['fsFile'].unlink(fullPath.replace('.mkv', '_backup.mkv'), function (er) {
												
												window['fsFile'].rename(fullPath, fullPath.replace('.mkv', '_backup.mkv'), function(err)
													{
														mainThis.saveFileMKV(fullPath, blob, chunks, isLast, secondTry, MROid);
													});
											});
										}
									else
										{
											window['fsFile'].rename(fullPath, fullPath.replace('.mkv', '_backup.mkv'), function(err)
												{
													mainThis.saveFileMKV(fullPath, blob, chunks, isLast, secondTry, MROid);
												});
										}
								}
						}
					else
						{
							mainThis.saveFileMKV(fullPath, blob, chunks, isLast, secondTry, MROid);
						}
				}
			else
				{
					let file = new File([blob], this.recordingFileFullV, {type: 'video/mkv'});
					mainThis.browserData = file;
					mainThis.sendLogData('RecordingNext', 'mediaRecorder file saved', 'Saved to Browser file');
					
					if ( isLast && mainThis.callBackOnStop )
						{
							setTimeout(function () { mainThis.callBackOnStop(); mainThis.callBackOnStop = false; }, 2000);
						}
				}
		}
	
	uploadFileToS3(sessionId, callback, secondTry)
		{
			var $ = window.$ || {};
			
			var mainThis = this;
			// Check is there available recording
			
			$('.modal:not(#session-saving-recording)').modal('hide');
			$('#session-saving-recording').modal('show');
			$('.main_loader').attr({'style':'display:none'});
			mainThis.progressBar = 5;
			mainThis.updateProgressBar();
			
			mainThis.sendLogData('RecordingNext', 'Started uploading files', 'Started file upload.');
			
			try
				{
					// Prepare link for upload
					let token = JSON.parse(localStorage.getItem('userData')).token;
					axios.defaults.headers.common['Authorization'] = token;
					axios.post(process.env.REACT_APP_API_URL+"/api/v1/upload/createLinkRecording", {'sessionId': sessionId, 'totalLinks': mainThis.currentRecordingItem+1}).then(res => {
						if ( res && res.data && res.data.result && res.data.result.fullNameV && res.data.result.fullLinkV && res.data.result.fullNameA && res.data.result.fullLinkA )
							{
								mainThis.sendLogData('RecordingNext', 'Received links', 'Link name:' + res.data.result.fullNameV[0]);
								
								// Receive File Name for uploading and full link for uploading
								var S3LinkV = res.data.result.fullLinkV;
								var S3NameV = res.data.result.fullNameV;
								
								var S3LinkA = res.data.result.fullLinkA;
								var S3NameA = res.data.result.fullNameA;
								
								var totalFiles = S3NameV.length;
								
								var passData = {'sessionId': sessionId, 'fileData': res.data.result};
								
								mainThis.progressBar = 15;
								mainThis.updateProgressBar();
								
								// Stop all agora streaming
								if ( window.logoutBeforeLeave ) { window.logoutBeforeLeave(); }
								
								var totalUploaded = 0;
								var totalUploaded1 = 0;
								
								var hasFailed = false;
								
								for ( var itm in S3NameV )
									{
										mainThis.sendLogData('RecordingNext', 'Received links', 'Link name:' + res.data.result.fullNameV[0]);
										
										var fileData = '';
										if ( window['electron'] )
											{
												if ( window['fsFile'].existsSync(mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+itm+'.mkv') )
													{
														fileData = window['fsFile'].readFileSync(mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+itm+'.mkv');
													}
												else
													{
														mainThis.sendLogData('RecordingError', 'File Not Found', 'Not existing:'+mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+itm+'.mkv');
														totalFiles--;
														hasFailed = true;
													}
											}
										else
											{
												fileData = 'browser';
											}
										
										if ( fileData )
											{
												var fileToUpload = window['electron'] ? new File([fileData], S3NameV[itm], {type: 'video/mkv'}) : mainThis.browserData;
												
												mainThis.uploadFileS3XHR(fileToUpload, S3LinkV[itm], 'video/mkv', function (itmback) {
													
													mainThis.sendLogData('RecordingNext', 'File MKV Uploaded', 'Starting next request');
													
													totalUploaded++;
													console.log('All success #1');
													mainThis.progressBar = 15+((50/totalFiles)*totalUploaded);
													mainThis.updateProgressBar(itmback);
													
													mainThis.checkAACSaved(function ()
														{
															if ( window['electron'] && mainThis.failedAudioFile == false )
																{
																	var fileData2 = window['fsFile'].readFileSync(mainThis.recordingPath+mainThis.uniqueRecordingFile + '_'+itmback+'.aac');
																	if ( fileData2 )
																		{
																			var fileToUpload2 = new File([fileData2], S3NameA[itmback], {type: 'audio/aac'});
																			
																			mainThis.uploadFileS3XHR(fileToUpload2, S3LinkA[itmback], 'audio/aac', function (itmback) {
																				
																				console.log('All success #2');
																				
																				mainThis.sendLogData('RecordingNext', 'File AAC Uploaded', 'Deleting files and starting next request');
																				
																				totalUploaded1++;
																				if ( totalUploaded == totalFiles )
																					{
																						mainThis.progressBar = 65+((35/totalFiles)*totalUploaded1);
																					}
																				mainThis.updateProgressBar(itmback, true);
																				
																				if ( totalUploaded1 == totalFiles )
																					{
																						mainThis.progressBar = 100;
																						mainThis.updateProgressBar();
																				
																						mainThis.doCleanUpEnd(hasFailed);
																						callback(passData);
																					}
																				
																			}, function (err) {
																									// In Case of Error
																									mainThis.sendLogData('RecordingError', 'Not Reading', ['Unable to UPLOAD AAC file', err]);
																									if ( !secondTry )
																										{
																											setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000);
																										}
																									else
																										{
																											mainThis.retryUploadPopupShow(sessionId, callback);
																										}
																								}, totalFiles, itmback);
																		} else { mainThis.sendLogData('RecordingError', 'Not Reading', 'Unable to read AAC file'); if ( !secondTry ) { setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000); } else { callback(false); } }
																}
															else
																{
																	console.log('All success #2', res);
																	
																	if ( mainThis.failedAudioFile == false )
																		{
																			mainThis.sendLogData('RecordingNext', 'Files Uploaded', 'Files Uploaded Successfuly');
																		}
																	else if ( window['electron'] )
																		{
																			mainThis.sendLogData('RecordingNext', 'Files Uploaded', 'Files Uploaded Successfuly, but audio failed');
																		}
																	
																	mainThis.progressBar = 100;
																	mainThis.updateProgressBar();
																	
																	totalUploaded1++;
																	if ( totalUploaded1 == totalFiles )
																		{
																			mainThis.doCleanUpEnd(hasFailed);
																			callback(passData);
																		}
																}
																
														}, itmback);
													
												}, function (err) {
																	// In Case of Error
																	mainThis.sendLogData('RecordingError', 'Not Reading', ['Unable to UPLOAD MKV file', err]);
																	if ( !secondTry )
																		{
																			setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000);
																		}
																	else
																		{
																			mainThis.retryUploadPopupShow(sessionId, callback);
																		}
																}, totalFiles, itm);
											}
										else
											{
												if ( !hasFailed )
													{
														mainThis.sendLogData('RecordingError', 'Not Reading', 'Unable to read MKV file');
														if ( !secondTry )
															{
																setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000);
															}
														else
															{
																mainThis.retryUploadPopupShow(sessionId, callback);
															}
													}
											}
										
									}
							}
					}).catch(err => {
							// In Case of Error
							mainThis.sendLogData('RecordingError', 'Not Uploading', ['Unable to UPLOAD files', err]);
							if ( !secondTry )
								{
									setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000);
								}
							else
								{
									mainThis.retryUploadPopupShow(sessionId, callback);
								}
						});
				}
			catch (err)
				{
					// In Case of Error
					console.log('Error found', err);
					mainThis.sendLogData('RecordingError', 'Not Uploading', ['Unable to UPLOAD files', err]);
					if ( !secondTry )
						{
							setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback, true); }, 3000);
						}
					else
						{
							mainThis.retryUploadPopupShow(sessionId, callback);
						}
				}
		}
	
	retryUploadPopupShow(sessionId, callback)
		{
			var $ = window.$ || {};
			
			$('.modal:not(#retry-upload)').modal('hide');
			$('#retry-upload').modal('show');
			
			var mainThis = this;
			
			window.retryUploadRec = function ()
				{
					window.$('.modal').modal('hide');
					window.$('.newprogressbarinfo').html('');
					
					mainThis.applyNewRecording({'recordingFile': mainThis.recordingFileFullT});
					console.log('Apply direct files');
					
					setTimeout(function () { mainThis.uploadFileToS3(sessionId, callback); }, 500);
				};
			
			 window.stopUploadRec = function ()
				{
					window.$('.modal').modal('hide');
					window.$('.newprogressbarinfo').html('');
					
					setTimeout(function () { callback(false); }, 500);
				};
		}
	
	doCleanUpEnd(leaveFiles)
		{
			this.recordVideoStream = false;
			this.recordAudioStream = false;
			this.aTrack = false;
			
			this.isRecordingNow = false;
			this.isRecordingStarted = false;
			this.hasRecordingFiles = false;
			
			this.mediaRecordObject = {};
			this.recordingInterval = 300000;
			
			this.callBackOnStop = false;
			
			console.log('Leave files', leaveFiles);
			
			if ( window['electron'] && !leaveFiles )
				{
					for ( var i = 0; i < this.currentRecordingItem+1; i++ )
						{
							try { window['fsFile'].unlink(this.recordingPath+this.uniqueRecordingFile + '_'+i+'.aac', function (er) { }); } catch (ee) { console.log('error del', ee); }
							try { window['fsFile'].unlink(this.recordingPath+this.uniqueRecordingFile + '_'+i+'.mkv', function (er) { }); } catch (ee) { console.log('error del', ee); }
							try { window['fsFile'].unlink(this.recordingPath+this.uniqueRecordingFile + '_'+i+'_backup.mkv', function (er) { }); } catch (ee) { console.log('error del', ee); }
						}
					
					try { window['fsFile'].unlink(this.recordingPath+this.recordingFileFullT, function (er) { }); } catch (ee) { console.log('error del', ee); }
				}
			
			this.recordingFileFullV = '';
			this.recordingFileFullA = '';
			
			this.browserData = '';
			
			this.progressBar = 0;
			this.saveTries = 3;
			
			this.failedAudioFile = false;
			
			this.recordingStarted = new Date().getTime();
			
			this.uniqueRecordingFile = 'rec_' + (new Date()).getTime();
			this.currentRecordingItem = 0;
		}
		
		
	saveFileForEC2(fileData, callback)
		{
			var mainThis = this;
			
			let token = JSON.parse(localStorage.getItem('userData')).token ? JSON.parse(localStorage.getItem('userData')).token : JSON.parse(localStorage.getItem('userData')).data.responseData.token;
			axios.defaults.headers.common['Authorization'] = token;
			
			mainThis.sendLogData('RecordingNext', 'EC2 Update called', 'Data for file');
			
			axios.post(process.env.REACT_APP_API_URL+"/api/v1/upload/saveDataEC2", {'fileData': fileData, 'recordingDuration': mainThis.recordingDuration}).then(res => {
				mainThis.sendLogData('RecordingNext', 'EC2 Update completed', 'Completed EC2 Update');
				callback();
			});
			
			mainThis.sendLogData('RecordingNext', 'EC2 Update completed', 'Completed EC2 Update');
			callback();
		}
	
	
	defaultLogData(dataObject, data)
		{
			this.dataObject = dataObject;
			this.logDetails = data;
		}
	
	sendLogData(rmessage, rtitle, rtext)
		{
			console.log('SAVE DATA', rmessage, rtitle, rtext);
			
			if ( !this.dataObject ) { return false; }
			
			let addObject = this.logDetails;
			
			addObject['message'] = rmessage;
			addObject['details'] = JSON.stringify({"action": rtitle, "msg": rtext});
			addObject['timestamp'] = Util.getCurrentTimestamp();
			// {"sessionId": currentUserData.sessionData.id, "event": Const.EVENT.MESSAGE, "eventType": "send", "userId": currentUserData.id, "toFromId": currentUserData.id, "message": RTMConst.START_SESSION_RECORDING, "details": JSON.stringify({"action": "recordingProcessing", "msg": hostlanguage.recordingExist}), "timestamp": Util.getCurrentTimestamp()};
			
			this.dataObject.addSessionData(addObject);
			this.dataObject.dumpData();
		}
	
	
	saveFileMKV(fullPath, blob, chunks, isLast, secondTry, MROid)
		{
			var mainThis = this;
			blob.arrayBuffer().then(dataBuffer => {
				console.log('try save 55', new Date());
				
				try
					{
						window['fsFile'].writeFile(fullPath, Buffer.from(dataBuffer), function (err)
							{
								console.log('try save 6', new Date());
								
								if ( !window['fsFile'].existsSync(fullPath) )
									{
										console.log('try save 7', new Date());
										mainThis.sendLogData('RecordingError', 'mediaRecorder file not saved', 'Unable to save MKV file');
										console.log('File not saved #1');
										if ( !secondTry ) { setTimeout(function () { mainThis.saveFileDate(chunks, isLast, true, false, MROid); }, 3000); }
									}
								else
									{
										var goodSize = mainThis.checkMKVSize(fullPath);
										
										if ( !goodSize )
											{
												//Not good, check backup
												if ( !secondTry )
													{
														mainThis.sendLogData('RecordingNext', 'mediaRecorder file not saved well', 'File not saved well, has zero bytes, trying again...');
														setTimeout(function () { mainThis.saveFileDate(chunks, isLast, true, true, MROid); }, 3000);
													}
												else
													{
														mainThis.sendLogData('RecordingNext', 'mediaRecorder file not saved well', 'File not saved well, has zero bytes AGAIN');
														
														if ( window['fsFile'].existsSync(fullPath.replace('.mkv', '_backup.mkv')) )
															{
																var goodSize2 = mainThis.checkMKVSize(fullPath.replace('.mkv', '_backup.mkv'));
																if ( goodSize2 )
																	{
																		window['fsFile'].unlink(fullPath, function (er)
																			{
																				window['fsFile'].rename(fullPath.replace('.mkv', '_backup.mkv'), fullPath, function(err)
																					{
																						mainThis.sendLogData('RecordingNext', 'mediaRecorder file saved from BACKUP', 'File taken from backup');
																						
																						if ( isLast && mainThis.callBackOnStop )
																							{
																								console.log('try save 91', new Date());
																								setTimeout(function () { mainThis.callBackOnStop(); mainThis.callBackOnStop = false; }, 2000);
																							}
																					});
																			});
																	}
																else
																	{
																		mainThis.sendLogData('RecordingError', 'mediaRecorder file not saved well, and no backup', 'File not saved well, has zero bytes AGAIN and no backup');
																		
																		if ( isLast && mainThis.callBackOnStop )
																			{
																				console.log('try save 92', new Date());
																				setTimeout(function () { mainThis.callBackOnStop(); mainThis.callBackOnStop = false; }, 2000);
																			}
																	}
															}
													}
											}
										else
											{
												console.log('try save 8', new Date());
												mainThis.sendLogData('RecordingNext', 'mediaRecorder file saved', 'Saved MKV file: ' + fullPath + ' File Size: ' + blob.size);
												
												if ( isLast && mainThis.callBackOnStop )
													{
														console.log('try save 9', new Date());
														setTimeout(function () { mainThis.callBackOnStop(); mainThis.callBackOnStop = false; }, 2000);
													}
											}
									}
							});
					}
				catch (err)
					{
						mainThis.sendLogData('RecordingError', 'Not Saving', 'Unable to read Buffer #2');
						console.log('Unable to read Buffer #2', err);
						
						mainThis.stopRecording(false);
					}
				
			}).catch(err => { 
				mainThis.sendLogData('RecordingError', 'Not Saving', 'Unable to read Buffer');
				console.log('Unable to read Buffer', err);
				
			});
		}
	
	uploadFileS3XHR(fileToUpload, S3LinkV, filetype, callback, callbackerror, totalFiles, currentFile)
		{
			var $ = window.$ || {};
			if ( filetype == 'video/mkv' ) { $('.newprogressbarinfo').append('<div id="uploadfl'+currentFile+'"></div>'); }
			
			var mainThis = this;
			var xhr = new XMLHttpRequest();
			try
				{
					xhr.onreadystatechange = function(e)
						{
							if ( xhr.readyState == 4 )
								{
									console.log('UPLOAD STATUS', xhr.status);
									if ( xhr.status === 200 )
										{
											callback(currentFile);
										}
									else
										{
											callbackerror('Status: '+xhr.status);
										}
								}
						};
					
					xhr.onerror = (err) => { console.log('UPLOAD ERROR', xhr, err); callbackerror(err); };
					
					xhr.addEventListener('progress', function(e)
						{
							var done = e.position || e.loaded, total = e.totalSize || e.total;
							console.log('xhr progress: ' + (Math.floor(done/total*1000)/10) + '%');
							
							$('.newprogressbarinfo #uploadfl'+currentFile).html('Upload progress #'+currentFile+': ' + Math.floor(done/1024/1024) + ' MB / ' + Math.floor(total/1024/1024) + ' MB (' + (Math.floor(done/total*1000)/10) + '%)');
							
						}, false);
					
					if ( xhr.upload )
						{
							xhr.upload.onprogress = function(e) {
								var done = e.position || e.loaded, total = e.totalSize || e.total;
								console.log('xhr.upload progress: ' + done + ' / ' + total + ' = ' + (Math.floor(done/total*1000)/10) + '%');
								$('.newprogressbarinfo #uploadfl'+currentFile).html('Upload progress #'+currentFile+': ' + Math.floor(done/1024/1024) + ' MB / ' + Math.floor(total/1024/1024) + ' MB (' + (Math.floor(done/total*1000)/10) + '%)');
							};
						}
					
					xhr.open('PUT', S3LinkV, true);
					xhr.setRequestHeader('Content-Type', filetype);
					xhr.send(fileToUpload); // `file` is a File object here 
				}
			catch (err) { console.log('UPLOAD ERROR', xhr, err); mainThis.sendLogData('RecordingError', 'Not Uploading', 'Unable to upload XHR'); }
		}
	
	
	updateProgressBar(itmid, onlyaudio)
		{
			var $ = window.$ || {};
			
			if ( itmid && onlyaudio && $('.newprogressbarinfo #uploadfl'+itmid).length > 0 ) { $('.newprogressbarinfo #uploadfl'+itmid).html(''); }
			if ( !itmid ) { $('.newprogressbarinfo').html(''); }
			
			$('#session-saving-recording .newprogressbar div').css('width', this.progressBar+'%');
		}
	
	
	
	
	checkOldRecordings(callback)
		{
			if ( window['electron'] && window['fsFile'] )
				{
					try
						{
							var allFiles = window['fsFile'].readdirSync(this.recordingPath);
							console.log('allFiles', allFiles);
							
							window['aaf'] = allFiles;
							
							var filesFound = [];
							for (var i in allFiles)
								{
									var ofile = allFiles[i];
									if ( ofile.substr(0, 4) == 'rec_' && ofile.substr(-4) == '.txt' )
										{
											if ( window['fsFile'].existsSync(this.recordingPath+ofile.replace('.txt', '_0.mkv')) && window['fsFile'].existsSync(this.recordingPath+ofile.replace('.txt', '_0.aac')) )
												{
													console.log('Found', ofile);
													
													var sessionData = this.getSessionData(this.recordingPath+ofile, ofile);
													if ( sessionData ) { filesFound.push(sessionData); }
												}
										}
								}
							
							if ( filesFound.length > 0 )
								{
									console.log('files', filesFound);
									callback(filesFound);
									return true;
								}
						} catch(e) { console.error(e); }
						
						callback(false);
				}
		}
	
	getSessionData(filePath, fileName)
		{
			try
				{
					var fileData = window['fsFile'].readFileSync(filePath);
					var sData = JSON.parse(fileData);
					if ( sData && sData['sessionData'] )
						{
							sData['sessionData']['recordingFile'] = fileName;
							return sData['sessionData'];
						}
					
				} catch(e) { console.error('2', e); }
			
			return false;
		}
	
	deleteOldRecordings(rItem)
		{
			try
			{
				var fileName = rItem['recordingFile'];
				window['fsFile'].unlink(this.recordingPath+fileName, function (er) { });
				
				var allFiles = window['fsFile'].readdirSync(this.recordingPath);
				console.log('allFiles', allFiles);
				
				window['aaf'] = allFiles;
				
				var filesFound = [];
				for (var i in allFiles)
					{
						var ofile = allFiles[i];
						console.log('Files', ofile, fileName);
						
						if ( ofile.substr(0, 4) == 'rec_' && ( ofile.substr(-4) == '.mkv' || ofile.substr(-4) == '.aac' ) && ofile.substr(0, 17) == fileName.substr(0, 17) )
							{
								console.log('Deleted', ofile);
								window['fsFile'].unlink(this.recordingPath+ofile, function (er) { });
							}
					}
			}
			catch (ee) { console.log('error del', ee); }
		}
		
		
	
	applyNewRecording(rItem)
		{
			if ( window['electron'] )
				{
					this.isRecordingStarted = true;
					this.hasRecordingFiles = true;
					
					var fileName = rItem['recordingFile'];
					this.progressBar = 0;
					this.saveTries = 3;
					
					this.failedAudioFile = false;
					
					this.recordingStarted = new Date().getTime();
					
					this.currentRecordingItem = -1;
					
					var allFiles = window['fsFile'].readdirSync(this.recordingPath);
					var filesFound = [];
					for ( var i in allFiles )
						{
							var ofile = allFiles[i];
							if ( ofile.substr(0, 4) == 'rec_' && ofile.substr(-4) == '.mkv' && ofile.substr(0, 17) == fileName.substr(0, 17) && ofile.substr(-10) !== 'backup.mkv' )
								{
									this.currentRecordingItem++;
								}
						}
					
					this.recordingFileFullV = fileName.replace('.txt', '_'+this.currentRecordingItem+'.mkv');
					this.recordingFileFullA = fileName.replace('.txt', '_'+this.currentRecordingItem+'.aac');
					this.recordingFileFullT = fileName;
					
					this.uniqueRecordingFile = fileName.replace('.txt', '');
				}
		}
	
	clipRecording()
		{
			var mainThis = this;
			if ( mainThis.isRecordingNow && window['electron'] )
				{
					if ( mainThis.lastClipTimer ) { clearTimeout(mainThis.lastClipTimer); }
					
					mainThis.lastClipTimer = setTimeout(function ()
						{
							if ( mainThis.isRecordingNow )
								{
									if ( window['electron'] ) { window['globalAgora'].agora.stopAudioRecording(); }
							
									mainThis.recordingDuration = new Date().getTime() - mainThis.recordingStarted;
									mainThis.mediaRecordObject[mainThis.currentRecordingItem].stop();
									
									mainThis.currentRecordingItem++;
									mainThis.startRecording(true);
								}
						}, 5000);
				}
		}
	// window['recContext']
}

export default recordingSession;